import { GET_CLOTHING_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_CLOTHING_TYPES_SUCCESS: {
      const clothingTypes = action.payload;

      if (!clothingTypes){
        return [...state];
      }

      return [
        ...state,
        ...clothingTypes
      ]
    }
    default:
      return state;
  }
}
